import { fullPageReloadWithDelay } from '@/utils/reload.ts';
import {
  getSessionStorage,
  SESSION_STORAGE_KEY,
  setSessionStorage,
} from '@/app/components/search/utils/sessionStorage';

const CHUNK_RELOAD_MIN_INTERVAL_MS = 60_000;

// Both webpack and Turbopack name it ChunkLoadError; only the message wording differs between them
export const isChunkLoadError = (error: Error) => error?.name === 'ChunkLoadError';

// At most one reload per tab per interval, so a chunk that is really missing never turns into a reload loop
const isChunkReloadAllowed = () => {
  const now = Date.now();
  const lastReloadAt = Number(getSessionStorage(SESSION_STORAGE_KEY.CHUNK_LOAD_ERROR_RELOAD_AT) ?? 0);
  if (now - lastReloadAt < CHUNK_RELOAD_MIN_INTERVAL_MS) return false;

  setSessionStorage(SESSION_STORAGE_KEY.CHUNK_LOAD_ERROR_RELOAD_AT, String(now));
  // Without storage the guard cannot hold across reloads, so skip the reload instead of risking a loop
  return getSessionStorage(SESSION_STORAGE_KEY.CHUNK_LOAD_ERROR_RELOAD_AT) === String(now);
};

export const handleChunkLoadError = (error: Error) => {
  if (isChunkLoadError(error) && isChunkReloadAllowed()) {
    fullPageReloadWithDelay(1000);
  }
};
